import React, {useRef, useState} from 'react'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizButton from '../../../../components/button/WizButton'
import DeleteCommentModal from './DeleteCommentModal'
import {ICommentList} from '../../../../apis/comment/getCommentList'
import WizSelectButton from '../../../../components/button/WizSelectButton'

interface IProps {
    className?: string
    onClick?: (e: string) => void
    search?: string
    checkList?: ICommentList[]
    onClickAllBanUser?: () => void
    searchList?: {id: string; value: string}[]
    searchTarget?: string
    onChangeSearchTarget?: (e: string) => void
}

const CommentSearchContainer: React.FC<IProps> = ({
    className,
    onClick,
    search,
    checkList,
    onClickAllBanUser,
    onChangeSearchTarget,
    searchList,
    searchTarget,
}) => {
    const [inputText, setInputText] = useState('')

    const commentDeleteModalRef = useRef<any>()
    return (
        <>
            <div className={'flex justify-between'}>
                <div className={'flex items-center gap-x-[10px]'}>
                    <WizButton
                        text={'Ban User All Check'}
                        type={'red'}
                        className={'bg-[#E56E73]'}
                        onClick={() => onClickAllBanUser()}
                    />
                    {checkList?.length > 0 && (
                        <WizButton
                            text={'Delete All'}
                            type={'red'}
                            onClick={() => commentDeleteModalRef?.current?.show()}
                        />
                    )}
                </div>
                <div className={`flex gap-[10px] w-full justify-end items-center ${className}`}>
                    <WizSelectButton
                        onChange={e => onChangeSearchTarget(e.id)}
                        data={searchList}
                        activeValue={searchList?.find(item => item?.id === searchTarget)}
                    />
                    <UnderLineInput
                        type={'text'}
                        inputClassName={'h-full'}
                        value={search || inputText}
                        onChanged={(e: string) => setInputText(e)}
                        onEnterKeyPress={() => onClick(inputText)}
                    />
                    <WizButton
                        size={'small'}
                        text={'Search'}
                        onClick={() => {
                            onClick(inputText)
                        }}
                    />
                    <WizButton
                        text={'Reset'}
                        className={'text-white'}
                        type={'blue'}
                        size={'small'}
                        onClick={() => {
                            onClick('')
                            setInputText('')
                        }}
                    />
                </div>
            </div>
            <DeleteCommentModal deleteList={checkList} ref={commentDeleteModalRef} />
        </>
    )
}

export default CommentSearchContainer
